/* Frío Club: cuenta atrás, nieve, fechas de entrega, packs y barra fija */
(function () {
  const BOXES = {};
  function init(root) {
  const pad = (n) => String(n).padStart(2, '0');

  // Cuenta atrás
  root.querySelectorAll('[data-fc-countdown]').forEach((el) => {
    const end = new Date(el.dataset.fcCountdown).getTime();
    if (isNaN(end)) return;
    const set = (u, v) => { const b = el.querySelector('[data-u="' + u + '"]'); if (b) b.textContent = pad(v); };
    const tick = () => {
      const d = end - Date.now();
      if (d <= 0) { if (el.dataset.fcHide === 'true') el.closest('.shopify-section').hidden = true; return; }
      const s = Math.floor(d / 1000);
      set('d', Math.floor(s / 86400)); set('h', Math.floor((s % 86400) / 3600)); set('m', Math.floor((s % 3600) / 60)); set('s', s % 60);
    };
    if (el.dataset.done) return; el.dataset.done = 1; tick(); setInterval(tick, 1000);
  });

  // Nieve
  root.querySelectorAll('[data-fc-snow]').forEach((box) => {
    if (box.dataset.done) return; box.dataset.done = 1;
    const n = parseInt(box.dataset.fcSnow, 10) || 40;
    for (let i = 0; i < n; i++) {
      const d = document.createElement('i'); const sz = 2 + Math.random() * 5;
      d.style.left = Math.random() * 100 + '%'; d.style.width = d.style.height = sz + 'px';
      d.style.opacity = 0.35 + Math.random() * 0.6; d.style.animationDuration = 7 + Math.random() * 9 + 's';
      d.style.animationDelay = -Math.random() * 16 + 's'; box.appendChild(d);
    }
  });

  // Fechas de entrega (días hábiles)
  const M = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  const D = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
  const fmtD = (d) => d.getDate() + ' ' + M[d.getMonth()];
  const rng = (a, b) => (a.getMonth() === b.getMonth() ? a.getDate() + '–' + fmtD(b) : fmtD(a) + ' – ' + fmtD(b));
  const addBiz = (d, n) => { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
  root.querySelectorAll('[data-fc-date]').forEach((el) => {
    const now = new Date(); const [a, b] = el.dataset.fcDate.split(',').map(Number);
    el.textContent = a === 0 && !b ? fmtD(now) : a === b ? fmtD(addBiz(now, a)) : rng(addBiz(now, a), addBiz(now, b));
  });

  // Packs
  const money = (cents, fmt) => {
    const v = (cents / 100).toFixed(2);
    const [i, dec] = v.split('.');
    const comma = i.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec;
    const dot = i.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + dec;
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
      .replace(/\{\{\s*amount\s*\}\}/, dot)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, i)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, i);
  };

  root.querySelectorAll('fc-bundles').forEach((box) => {
    if (box.dataset.done) return; box.dataset.done = 1;
    const data = JSON.parse(box.querySelector('[data-fc-variants]').textContent);
    const fmt = box.dataset.moneyFormat;
    const formId = box.dataset.form;
    const tiers = [...box.querySelectorAll('.fc-pk')];
    const currentVariant = () => {
      const f = document.getElementById(formId);
      const inp = f && f.querySelector('[name="id"]');
      return inp ? Number(inp.value) : data.variants[0].id;
    };
    const priceOf = (id) => { const v = data.variants.find((x) => x.id === Number(id)); return v ? v.price : data.variants[0].price; };

    const unitIds = (pk) => {
      const sels = [...pk.querySelectorAll('select')];
      if (!sels.length) { const q = Number(pk.dataset.q); return Array(q).fill(currentVariant()); }
      return sels.map((s) => Number(s.value));
    };
    const calc = (pk) => {
      const ids = unitIds(pk); const full = ids.reduce((t, id) => t + priceOf(id), 0);
      const type = pk.dataset.dt, val = Number(pk.dataset.dv) || 0;
      let off = type === 'percent' ? Math.round((full * val) / 100) : type === 'amount' ? Math.round(val * 100) : 0;
      off = Math.min(off, full);
      return { full, total: full - off, off, q: ids.length };
    };
    const paint = () => {
      tiers.forEach((pk) => {
        const c = calc(pk);
        pk.querySelector('[data-fc-total]').textContent = money(c.total, fmt);
        const s = pk.querySelector('[data-fc-full]'); if (s) { s.textContent = money(c.full, fmt); s.hidden = c.off <= 0; }
        const sv = pk.querySelector('[data-fc-save]'); if (sv) { sv.textContent = (box.dataset.saveLabel || 'Ahorras') + ' ' + money(c.off, fmt); sv.hidden = c.off <= 0; }
        const u = pk.querySelector('[data-fc-unit]'); if (u) u.textContent = c.q > 1 ? money(Math.round(c.total / c.q), fmt) + ' ' + (box.dataset.eachLabel || 'cada una') : '';
      });
      const sel = box.querySelector('.fc-pk[aria-checked="true"]');
      if (sel) { const c = calc(sel); document.querySelectorAll('[data-fc-sticky-price]').forEach((e) => (e.textContent = money(c.total, fmt))); }
    };
    const choose = (pk) => { tiers.forEach((t) => t.setAttribute('aria-checked', t === pk)); paint(); };
    tiers.forEach((pk) => {
      pk.addEventListener('click', (e) => { if (e.target.closest('select')) return; choose(pk); });
      pk.addEventListener('keydown', (e) => { if (e.target.closest('select')) return; if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(pk); } });
      pk.querySelectorAll('select').forEach((s) => s.addEventListener('change', paint));
    });
    document.addEventListener('change', (e) => { if (e.target.closest && e.target.closest('variant-selects')) setTimeout(paint, 50); });
    paint();

    BOXES[formId] = { box, unitIds };
  });

  // Barra fija
  root.querySelectorAll('[data-fc-sticky]').forEach((bar) => {
    if (bar.dataset.done) return; bar.dataset.done = 1;
    const target = document.querySelector('.product-form__submit');
    const btn = bar.querySelector('button');
    if (!target) { btn.addEventListener('click', () => (window.location.href = bar.dataset.url)); return; }
    btn.addEventListener('click', () => target.click());
    new IntersectionObserver(([en]) => bar.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(target);
  });
  }
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
    // Añadir al carrito: varias unidades (y personajes) en una sola petición
  document.addEventListener('submit', (e) => {
      const form = e.target;
      const reg = form && form.getAttribute && BOXES[form.getAttribute('id')];
      if (!reg || !document.body.contains(reg.box)) return;
      const { box, unitIds } = reg;
      const sel = box.querySelector('.fc-pk[aria-checked="true"]');
      if (!sel) return;
      e.preventDefault(); e.stopImmediatePropagation();
      const counts = {}; unitIds(sel).forEach((id) => (counts[id] = (counts[id] || 0) + 1));
      const items = Object.keys(counts).map((id) => ({ id: Number(id), quantity: counts[id] }));
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items };
      if (cart && cart.getSectionsToRender) { body.sections = cart.getSectionsToRender().map((s) => s.id); body.sections_url = window.location.pathname; }
      const btn = form.querySelector('[type="submit"]'); if (btn) btn.classList.add('loading');
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) { alert(res.description || res.message); return; }
          if (cart && cart.tagName === 'CART-DRAWER' && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); }
          else window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        })
        .catch(() => (window.location.href = '/cart'))
        .finally(() => btn && btn.classList.remove('loading'));
    }, true);
})();
